module.exports = __webpack_public_path__ + "img/soc_vk.b51bd667.svg";